import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ExpenseReportsContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "forExport",
})<{ forExport?: boolean }>(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  }),
  ({ forExport }) => ({
    ...(!!forExport && {
      gap: "0px",
    }),
  })
);

export const NoItemsContainer = styled(Grid)({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
